// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1eqlg","list":"styles_list__2TGXi"};